import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import {
  fleetsViewSlice,
  FleetsViewState,
  tabAlertsToggleIsSidebarFilterOpenAction,
  tabAnomaliesToggleIsSidebarFilterOpenAction,
  tabAttacksToggleIsSidebarFilterOpenAction,
  tabInventoryToggleIsSidebarFilterOpenAction,
  tabLogsToggleIsFiltersPanelOpen,
} from './fleetsView.slice';

export const fleetsViewMiddleware: Middleware = (api) => (next) => (action) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const actionType = action?.type as string;
  const fleetsViewStateBeforeAction = api.getState()?.[fleetsViewSlice.name];

  if (fleetsViewStateBeforeAction) {
    // NOTE: Middleware is executed BEFORE given action
    fleetsViewMiddlewaresBeforeAction[actionType]?.(fleetsViewStateBeforeAction);
  }

  const result = next(action);
  const fleetsViewStateAfterAction = api.getState()?.[fleetsViewSlice.name];

  if (fleetsViewStateAfterAction) {
    // NOTE: Middleware is executed AFTER given action
    fleetsViewMiddlewaresAfterAction[actionType]?.(fleetsViewStateAfterAction);
  }

  return result;
};

type MiddlewareCallback = (state: FleetsViewState) => unknown;

const fleetsViewMiddlewaresBeforeAction: Record<string, MiddlewareCallback> = {};

const fleetsViewMiddlewaresAfterAction: Record<string, MiddlewareCallback> = {
  [tabAlertsToggleIsSidebarFilterOpenAction.type]: (state: FleetsViewState) => {
    appStorage.fleetsView.setIsSidebarFilterOpenForTabAlerts(state.tabAlerts.isSidebarFilterOpen);
  },

  [tabInventoryToggleIsSidebarFilterOpenAction.type]: (state: FleetsViewState) => {
    appStorage.fleetsView.setIsSidebarFilterOpenForTabInventory(state.tabInventory.isSidebarFilterOpen);
  },

  [tabAttacksToggleIsSidebarFilterOpenAction.type]: (state: FleetsViewState) => {
    appStorage.fleetsView.setIsSidebarFilterOpenForTabAttacks(state.tabAttacks.isSidebarFilterOpen);
  },
  [tabAnomaliesToggleIsSidebarFilterOpenAction.type]: (state: FleetsViewState) => {
    appStorage.fleetsView.setIsSidebarFilterOpenForTabAnomalies(state.tabAnomalies.isSidebarFilterOpen);
  },
  [tabLogsToggleIsFiltersPanelOpen.type]: (state: FleetsViewState) => {
    appStorage.fleetsView.setIsSidebarFilterOpenForTabLogs(state.tabLogs.isFiltersPanelOpen);
  },
};
